class ProductZoom extends HTMLElement {
  constructor() {
    super();
    this.bindEvents = this.bindEvents.bind(this);
    this.openZoom = this.openZoom.bind(this);
    this.closeZoom = this.closeZoom.bind(this);
    this.onEchap = this.onEchap.bind(this);
    this.activeIndex = 0;
  }
  connectedCallback() {
    this.mobileBreakpoint = 1024;
    this.isMobile = window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    this.bindEvents();
  }
  lockScroll() {
    this.bodyTopPosition = document.documentElement.scrollTop;
    document.body.style.top = `-${this.bodyTopPosition}px`;
    document.documentElement.classList.add("lock-scroll");
  }
  unLockScroll() {
    document.documentElement.classList.remove("lock-scroll");
    window.scrollTo({ left: 0, top: this.bodyTopPosition, behavior: "instant" });
    document.body.style.top = `unset`;
  }
  openZoom() {
    if (this.isZoomOpen) {
      return;
    }
    this.lockScroll();
    if (this.zoomBtnCloses && this.zoomBtnCloses.length > 0) {
      for (const zoomBtnClose of this.zoomBtnCloses) {
        zoomBtnClose.addEventListener("click", this.closeZoom);
      }
    }
    setTimeout(() => {
      this.ZoomEl.classList.add("product-zoom--open");
    }, 50);
    this.isZoomOpen = true;
    document.addEventListener("keyup", this.onEchap);
    document.addEventListener("click", this.onClickOutside);
  }
  closeZoom() {
    if (!this.isZoomOpen) {
      return;
    }
    this.unLockScroll();
    document.removeEventListener("keyup", this.onEchap);
    document.removeEventListener("click", this.onClickOutside);
    this.isZoomOpen = false;
    this.ZoomEl.classList.remove("product-zoom--open");
  }
  onEchap(e) {
    if (e.keyCode === 27) {
      this.closeZoom();
    }
  }
  centerTheImage() {
    let container = document.querySelector(".product-zoom__swiper-container");
    let images = this.querySelectorAll(".js-product-zoom-media");
    setTimeout(() => {
      images[this.activeIndex].scroll(
        (images[this.activeIndex].children[0].getBoundingClientRect().width - container.getBoundingClientRect().width) / 2,
        0
      );
    }, 50);
  }
  bindEvents() {
    this.ZoomEl = this;
    this.isZoomOpen = false;
    this.zoomSlider = this.querySelector("w3-slider");
    this.zoomBtnCloses = this.ZoomEl.querySelectorAll(".js-zoom-close");
    this.productMedias = document.querySelectorAll(".js-product-gallery-item");
    this.productZoomMedias = this.ZoomEl.querySelectorAll(".js-product-zoom-media");
    if (this.productMedias && this.productMedias.length > 0) {
      for (const productMedia of this.productMedias) {
        if (productMedia.hasAttribute("is-video")) {
          const video = productMedia.querySelector("video");
          if (video.paused) {
            productMedia.classList.add("u-cursor-pause");
            productMedia.classList.remove("u-cursor-play");
          } else {
            productMedia.classList.add("u-cursor-play");
            productMedia.classList.remove("u-cursor-pause");
          }
          productMedia.addEventListener("click", () => {
            if (video.paused) {
              video.play();
              productMedia.classList.add("u-cursor-pause");
              productMedia.classList.remove("u-cursor-play");
            } else {
              video.pause();
              productMedia.classList.add("u-cursor-play");
              productMedia.classList.remove("u-cursor-pause");
            }
          });
        } else {
          productMedia.addEventListener("click", () => {
            this.activeIndex = productMedia.dataset.customIndex ? productMedia.dataset.customIndex : productMedia.dataset.index;
            if (this.zoomSlider.Slider && this.activeIndex) {
              this.zoomSlider.Slider.slideToLoop(this.activeIndex);
            }
            this.openZoom();
            if (this.isMobile) {
              this.centerTheImage();
            }
          });
        }
      }
    }
  }
  disconnectedCallback() {
    if (this.productMedias && this.productMedias.length > 0) {
      for (const productMedia of this.productMedias) {
        productMedia.removeEventListener("click", this.openZoom);
      }
    }
    if (this.zoomBtnCloses && this.zoomBtnCloses.length > 0) {
      for (const zoomBtnClose of this.zoomBtnCloses) {
        zoomBtnClose.removeEventListener("click", this.closeZoom);
      }
    }
  }
}
if (customElements.get("w3-zoom") === void 0) {
  customElements.define("w3-zoom", ProductZoom);
}
